import {get} from '../../utils'

// Action Types

export const actionTypes = {
  UPDATE_POSTCODE_REQUEST: 'UPDATE_POSTCODE_REQUEST',
  UPDATE_POSTCODE_SUCCESS: 'UPDATE_POSTCODE_SUCCESS',
  LOCATION_FETCH_REQUEST: 'LOCATION_FETCH_REQUEST',
  POSTCODE_INPUT_REQUEST: 'POSTCODE_INPUT_REQUEST',
  POSTCODE_INPUT_CANCEL: 'POSTCODE_INPUT_CANCEL',
  POSTCODE_POPUP_SHOW: 'POSTCODE_POPUP_SHOW',
  POSTCODE_POPUP_HIDE: 'POSTCODE_POPUP_HIDE',
  LOCATION_FETCH_START: 'LOCATION_FETCH_START',
  LOCATION_FETCH_SUCCESS: 'LOCATION_FETCH_SUCCESS',
  LOCATION_FETCH_ERROR: 'LOCATION_FETCH_ERROR',
  LOCATION_CONFIRMED: 'LOCATION_CONFIRMED',
}

// Action Creators

const updatePostcode = postcode => ({
  type: actionTypes.UPDATE_POSTCODE_REQUEST,
  payload: {postcode},
})

const fetchLocation = () => ({
  type: actionTypes.LOCATION_FETCH_REQUEST,
})

const requestPostcodeInput = () => ({
  type: actionTypes.POSTCODE_INPUT_REQUEST,
})

const cancelPostcodeInput = () => ({
  type: actionTypes.POSTCODE_INPUT_CANCEL,
})

export const actionCreators = {
  updatePostcode,
  fetchLocation,
  requestPostcodeInput,
  cancelPostcodeInput,
}

// Selectors

const getLocation = get('location')

export const selectors = {
  getLocation,
}



// WEBPACK FOOTER //
// ./src/store/actions/location.js